var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 365.779,
    height: 311.677,
    viewBox: "0 0 365.779 311.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(-251.221 -317.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 153,
    cy: 153,
    r: 153,
    transform: "translate(263.276 317.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(416.276 459.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M-1087.7,527.2V652.223h-11.468V527.181q3.483.043,7.037.038C-1090.641,527.219-1089.171,527.21-1087.7,527.2Z",
    transform: "translate(1192.426 -494.124)",
    fill: "#f6f7f7",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M-947.479,520.757a2.982,2.982,0,0,1,0,.751c0,3.117-6.143,6.016-16.685,8.43-17.18,3.936-46.044,6.587-79.057,6.8-1.469.01-2.939.019-4.429.019q-3.549,0-7.037-.036c-52.035-.548-93.123-7.154-93.123-15.215a2.216,2.216,0,0,1,.1-.672",
    transform: "translate(1148.174 -499.968)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M-1147.821,524.324l-.18-6.67,16.285,2.4,1.562,8.172Z",
    transform: "translate(1148.001 -502.791)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M-964.164,529.9c-17.18,3.936-46.044,6.587-79.057,6.8-1.469.01-2.939.019-4.429.019q-3.549,0-7.037-.036c-52.035-.548-93.123-7.154-93.123-15.215a2.216,2.216,0,0,1,.1-.672",
    transform: "translate(1148.174 -499.93)",
    fill: "#f6f7f7",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M-947.6,525.12c0,8.418-44.844,15.249-100.171,15.249-16.941,0-32.9-.64-46.892-1.77-9.552-.773-18.187-1.774-25.589-2.954-17.149-2.739-27.68-6.445-27.68-10.524a2.211,2.211,0,0,1,.1-.672c.3-1.068,1.327-2.107,3.014-3.111,11.063-6.59,50.321-11.466,97.049-11.466s86,4.876,97.06,11.466c1.685,1,2.716,2.043,3.012,3.111A2.476,2.476,0,0,1-947.6,525.12Z",
    transform: "translate(1148.065 -509.871)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M-1120.25,535.645c-17.149-2.739-27.68-6.445-27.68-10.524a2.211,2.211,0,0,1,.1-.672c.3-1.068,1.327-2.107,3.014-3.111,11.063-6.59,50.321-11.466,97.049-11.466s86,4.876,97.06,11.466c1.685,1,2.716,2.043,3.012,3.111a2.476,2.476,0,0,1,.1.672c0,8.418-44.844,15.249-100.171,15.249-11.134,0-21.844-.275-31.851-.787",
    transform: "translate(1148.065 -509.871)",
    fill: "#f6f7f7",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    d: "M6.294,0H58.173a6.294,6.294,0,0,1,6.294,6.294v7.474a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6.294A6.294,6.294,0,0,1,6.294,0Z",
    transform: "translate(67.296 151.592)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M2.681,9.8l-.018,0L0,0,6.181.895A4.482,4.482,0,0,1,8.253.38a4.758,4.758,0,0,1,3.169,1.274l2.561.371V8.106h0c-.035,4.178-2.587,7.552-5.73,7.552C5.548,15.658,3.281,13.158,2.681,9.8Z",
    transform: "translate(344.291 410.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Model_1",
    "data-name": "Model 1",
    transform: "translate(251.328 357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M-1194.238,621.765c5.495-3.189,34.654-20.211,34.226-29.375-.187-3.991-5.446-17.927-7.125-21.784-12.665-29.213-14.772-30.726-23.133-73.748-1.98-10.188-3.1-26.564-14.327-21.011-6.51,3.214-24.8,10.416-29.777,18.685.034-.048.069-.094.1-.139,2.219-2.907,11.913-7.614,15.047,5.615,5.305,22.39,2.48,43.945,17.176,96.027,0,0,9.186,23.037,5.384,25.191Z",
    transform: "translate(1234.373 -439.179)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M-1150.476,570.167l4.809-34.835a.084.084,0,0,1,.162-.015l1.738,5.311a.085.085,0,0,0,.118.048l22.439-11.837a.08.08,0,0,0,.042-.092c-.4-1.608-8.825-35.183-20.178-39.587a60.591,60.591,0,0,0-9.909-2.689v0s-1.012,13.37-5.284,13.37c-4.249,0-8.113-11.2-8.231-15.211a.08.08,0,0,0-.074-.076,113.092,113.092,0,0,0-15.968-.659c-4.631.445-13.891,2.087-20.3,22.413s-7.419,56.209-7.182,60.365c0,0-5.1,7.473,57.739,3.565A.089.089,0,0,0-1150.476,570.167Z",
    transform: "translate(1258.007 -430.915)",
    fill: "#0555e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M-1121.337,570.522l9.406,12.527-10.147,8.9-10.19-12.005Z",
    transform: "translate(1327.263 -352.029)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M-1172.035,495.549l.8-11.568-9.616-10.15-4.705,19.81",
    transform: "translate(1278.787 -439.993)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M-1183.733,485.231c.63,1.5,2.771,6.031,6.321,8.118a7.228,7.228,0,0,0,5.655.829c7.573-1.95,8.946-21.509,9.06-23.411a13.712,13.712,0,0,1-6.709-4.475c-2.353,9.321-8.7,2.273-8.7,2.273C-1176.343,473.236-1182.683,483.568-1183.733,485.231Z",
    transform: "translate(1280.442 -446.851)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M-1182.617,474.153a68.445,68.445,0,0,0-1.709,13.636,12.031,12.031,0,0,0,3.075,8.244l.359.4a8.677,8.677,0,0,0,8.309,2.668h0a12,12,0,0,0,7.608-5.387,101.553,101.553,0,0,0,6.153-12.217s7.339-15.114-6.915-19.145C-1179.935,458.341-1182.617,474.153-1182.617,474.153Z",
    transform: "translate(1279.901 -451.026)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M-1179.879,486.591l-.027.151a2.834,2.834,0,0,1-3.325,2.318l-.021-.006-.59-2.378a26.085,26.085,0,0,1-.724-3.319c-.834-4.471-1.761-6.4-1.165-9.692,1.574-8.706,6.608-7.219,6.608-7.219a4.944,4.944,0,0,1,.342-.741c6.123-13.118,16.472-10.3,23.316-6.052a16.811,16.811,0,0,1,2.746,1.9c.65.5,1.241.991,1.757,1.45,5.744,5.109,8.779,3.963,8.779,3.963-.676,1.234-3.023,1.713-3.023,1.713,3.831.693,4.763-1.963,4.763-1.963.84,5.351-4.511,9.367-6.986,9.249a9.221,9.221,0,0,0,4.27.772s-9.025,9.9-30.349-3.065c-1.186,4.186-5.227,6.566-5.227,6.566l-1.062,5.9",
    transform: "translate(1278.452 -456.112)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M-1154.966,508.219l8.071,22.323,47.887-22.336s3.027,7.374-4.807,12.364c-5.88,3.386-7.832,0-7.832,0l-49.674,21.947a4.443,4.443,0,0,1-6-2.639l-7.129-21.427Z",
    transform: "translate(1288.885 -408.72)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M-1169.265,504.581a46.547,46.547,0,0,1-26.32,14.909s18.425,31.961,32.131,34.1c4.629.89,66.354-25.5,70.626-27.454,0,0,2.286-1.329,7.448-4.534,3.006-1.864,8.267,3.359,9.346-.848.817-3.185,1.724-12.862-1.127-14.495-2.332-1.335-8.47-5.042-11.348-5.363-5.067-.567-11.571,11.571-14.776,12.994s-51.574,16.643-53.583,16.913S-1169.265,504.581-1169.265,504.581Z",
    transform: "translate(1269.66 -415.389)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M-1150.52,534.349s6.4-8.684,50.316,67.456l-14.961,10.446s-35.844-32.567-39.386-38.54S-1150.52,534.349-1150.52,534.349Z",
    transform: "translate(1306.131 -385.21)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M-1164.671,582.406l-7.343,11.3-11.572-6.339,7.122-12.149Z",
    transform: "translate(1280.577 -347.757)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M-1162.4,583.364c-2.561,1.358-10.79,4.337-14.334-4.127-.151-.361-.592-.369-.894,0-1.732,2.135-4.066,4.95-5.916,7.171a48.711,48.711,0,0,0-5.374,7.937h0l37.33,20.27h0c1.492-2.744,1.306-5.853-.407-7.392-4.217-3.787-10.675-11.628-9.673-23.3C-1161.623,583.431-1161.98,583.142-1162.4,583.364Z",
    transform: "translate(1275.728 -344.349)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M-1120.272,572.635c.151,2.893-.621,11.613-9.789,11.254-.391-.015-.584.38-.374.81,1.205,2.473,2.771,5.777,4,8.391a48.843,48.843,0,0,0,4.927,8.223h0l34.133-25.289h0c-1.86-2.509-4.757-3.653-6.875-2.75-5.212,2.223-15.047,4.769-25.207-1.066C-1119.884,571.963-1120.3,572.165-1120.272,572.635Z",
    transform: "translate(1328.851 -350.59)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M-1150.619,530.235s55.295-3.434,57.432,19.708-22.579,34.18-43.051,74.768l-20.323-9.969s22.785-38.808,22.607-41.3-1.068-4.629-5.519-3.739-65.578,15.085-68.773-41.926Z",
    transform: "translate(1258.141 -390.916)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 7.122,
    height: 28.993,
    rx: 0.573,
    transform: "translate(96.512 228.175) rotate(-69.272)",
    fill: "#125ae2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 28.993,
    height: 7.122,
    rx: 0.584,
    transform: "translate(185.024 228.282) rotate(-40.762)",
    fill: "#125ae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M-1145.5,520.174l21.026,1.331.535-5.487-16.149-1.333a6.049,6.049,0,0,0-6.252,4.161l-.021.059A.97.97,0,0,0-1145.5,520.174Z",
    transform: "translate(1314.394 -402.845)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M-1145.562,519.743l2.334-2.758,20.686-4.455.53,5.835-10.078,1.7Z",
    transform: "translate(1315.168 -404.788)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M-1069.1,498.513l-37.423-15.4a1.72,1.72,0,0,0-2.236.919l-26.6,62.588a2.919,2.919,0,0,0,1.295,3.707h0",
    transform: "translate(1324.238 -431.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M-1106.494,483.375l-28.3,66.594,48.208-5.267,19.615-46.519a1.736,1.736,0,0,0-1.064-2.326Z",
    transform: "translate(1324.966 -431.31)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x1: 10.317,
    y1: 26.629,
    transform: "translate(90.079 62.564)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x1: 11.087,
    y1: 23.5,
    transform: "translate(62.989 80.601)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 8.345,
    y1: 18.94,
    transform: "translate(103.995 85.476)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M-1205.637,555.472l.172,79.052h9.1l-.172-79.063q-2.765.026-5.586.023C-1203.3,555.484-1204.47,555.478-1205.637,555.472Z",
    transform: "translate(1260.515 -365.731)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    d: "M4.325,0H46.833a4.325,4.325,0,0,1,4.325,4.325V9.461a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.325A4.325,4.325,0,0,1,4.325,0Z",
    transform: "translate(34.342 262.715)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M-1216.533,548.107s-3.212,16.153,10.321,18.083,34.068,3.023,34.068,3.023,10.164-.873,6.682-13.269Z",
    transform: "translate(1250.301 -372.421)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M-1112.975,620.36a12.517,12.517,0,0,1-3.632,1.354,7.373,7.373,0,0,1-.743.109c-1.427.143-4.278.241-7.263.294-4.2.09-8.678.117-9.906.153-5.488.136-9.745.073-12.23-.053-8.794-.449-17.562-1.434-26.331-2.366-2.5-.26-5.011-.521-7.513-.762-.735-.082-1.478-.143-2.213-.216l-7.568-.7q-5.431-.5-10.864-1v-.01c-1.48-.124-2.735-3.227-3.749-7.333-2.08-8.382-3.182-20.961-3.182-20.961q-.538-3.24-1.085-6.312c-8.724-48.664-19.94-66.5-24.494-88.155-2.806-13.341,8.275-13.1,11.611-11.378.044.027.1.053.151.082,2.421,1.335,4.457,4.4,7.146,9.547,8.661,16.586,15.654,45.985,20.073,67.815.34,1.524.682,3.058,1.014,4.591q1.129,5.217,2.133,10.481c.546,2.859,1.075,5.727,1.568,8.605.349,2.009.682,4.016,1,6.035.117.726.243,1.478.4,2.206a7.629,7.629,0,0,0,1.793,3.818,5.428,5.428,0,0,0,2.637,1.327c.413.1.842.18,1.255.252.43.08.852.153,1.291.223q3.549.619,7.387,1.138c11.3,1.543,24.108,2.609,35.853,4.016,1.82.332,12.335,1.47,16.29,2,.573.073,1,.143,1.255.189q2.945.55,5.639,1.085c.422.08.825.16,1.228.242l.25.054a3.454,3.454,0,0,1,2.591,2.259C-1109.793,613.126-1109.864,618.344-1112.975,620.36Z",
    transform: "translate(1234.531 -432.391)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin4);
export default __webpack_public_path__ + "static/media/login-4.80641b4b809571f3b0be5a04dcc948f1.svg";
export { ForwardRef as ReactComponent };